export const BREAKPOINTS = {
    SMALL_NARROW: 360,
    SMALL: 480,
    SMALL_WIDE: 660,
    MEDIUM_NARROW: 792,
    MEDIUM: 960,
    MEDIUM_WIDE: 1080,
    LARGE_NARROW: 1152,
    LARGE: 1272,
    LARGE_WIDE: 1608,
};
